<template>
  <div>
    <div class="section">
      <el-form :inline="true" :disabled="readonly" label-width="85px" label-position="left" style="padding-top:5px">
        <el-form-item :label="$t('SeaExport.OrderNo2')">
          <el-input v-model="poList.poNo" no="1" maxlength="32" style="width: 161px;" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ConsignationCompany')">
          <el-input :value="customerName" :disabled="true" style="width: 161px;" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Salesman')">
          <cargo-user-select
            no="2"
            style="width: 161px;"
            :disabled="true"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'sales'}"
            :default-value="poList.sales||''"
          />
        </el-form-item>
      </el-form>
      <el-form :disabled="readonly" :inline="true" label-width="85px" label-position="left">
        <el-form-item :label="$t('SeaExport.SupportSales')">
          <cargo-user-select
            no="3"
            style="width: 161px;"
            :default-value="poList.supportor||''"
            :static-options="officeUserList"
            @change="p=>{poList.supportor=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.OrderCurrency')">
          <cargo-advance-select
            no="4"
            style="width: 161px;"
            filterable
            :clearable="false"
            :select-type="selectTypeNames.basic_data_Currency"
            :default-value="poList.poCurrency"
            @parentCallBack="p=>{poList.poCurrency=p.value;poCurrencyCB_changeHandler(p.value)}"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.OrderExchangeRate')">
          <el-input-number v-model="poList.poExchangeRate" no="5" style="width: 161px;" :precision="6" :controls="false" @change="poExchangeRateChange" />
        </el-form-item>
      </el-form>
      <el-form :disabled="readonly" :inline="true" label-width="85px" label-position="left">
        <el-form-item :label="$t('SeaExport.OrderAmount')">
          <el-input-number no="6" style="width: 161px;" :precision="2" :value="poList.poAmount||0.00" :controls="false" :disabled="true" @input="value=>{poList.poAmount=value||''}" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.TheAmountOfWriteOffs')">
          <el-input-number no="7" style="width: 161px;" :precision="2" :value="poList.poDeclareAmount||0.00" :controls="false" :disabled="true" @input="value=>{poList.poDeclareAmount=value||''}" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Difference')">
          <el-input-number no="8" style="width: 161px;" :precision="2" :value="poList.diffAmount||0.00" :controls="false" :disabled="true" @input="value=>{poList.diffAmount=value||''}" />
        </el-form-item>
      </el-form>
      <el-form :disabled="readonly" :inline="true" label-width="85px" label-position="left">
        <el-form-item :label="$t('SeaExport.ServiceFeeDiscountRate')">
          <el-input v-model="poList.commisionDiscount" no="9" style="width: 161px;" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.TheFirstBusinessOrNot')">
          <el-select v-model="poList.firstPo" no="10" style="width: 161px;">
            <el-option :label="$t('SeaExport.No')" :value="0" />
            <el-option :label="$t('SeaExport.Yes')" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.FrameContractNumber')">
          <el-input v-model="poList.faContract" no="11" maxlength="32" style="width: 161px;" />
        </el-form-item>
      </el-form>
      <el-form :disabled="readonly" :inline="true" label-width="85px" label-position="left">
        <el-form-item :label="$t('SeaExport.OperatingInstructions')">
          <el-input v-model="poList.opRemarks" no="12" type="textarea" :rows="3" maxlength="256" style="width: 161px;" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Remarks')">
          <el-input v-model="poList.remarks" no="13" type="textarea" :rows="3" maxlength="256" style="width: 161px;" />
        </el-form-item>
      </el-form>
    </div>
    <div class="section" style="flex: 1">
      <div class="app-main-inner-row operations">
        <div v-show="cooperateEdit" class="triggers">
          <div>
            <el-button no="14" type="primary" :disabled="readonly" @click="addBtnClickHandler(true)">{{ $t('SeaExport.Add2') }}</el-button>
            <el-button no="15" type="primary" :disabled="readonly" @click="addBtnClickHandler(false)">{{ $t('SeaExport.Edit') }}</el-button>
            <el-button no="16" type="danger" :disabled="readonly" @click="delBtnClickHandler">{{ $t('SeaExport.Delete') }}</el-button>
          </div>
        </div>
      </div>
      <div style="flex-grow:1;padding:10px;">
        <cargo-ag-grid
          config-module="130123"
          :grid-options="gridOptions"
          :grid-params.sync="gridParams"
          :column-defs="columnDefs"
          :row-data="forexPayment"
          style="width:100%;height:100%"
          @gridReady="params=>gridApi=params.api"
        />
      </div>
      <div style="padding:5px 10px;color:#404144;">
        <span>
          {{ total.total }}&nbsp;&nbsp;&nbsp;&nbsp;
          {{ $t('SeaExport.OrderAmount') }}:{{ total.orderAmount }}&nbsp;&nbsp;&nbsp;
          {{ $t('SeaExport.PaymentAmount') }}:{{ total.paymentAmount }}&nbsp;&nbsp;&nbsp;
          {{ $t('SeaExport.UnpaidAmount') }}:{{ total.unpaidAmount }}&nbsp;&nbsp;&nbsp;
        </span>
      </div>
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="420px"
      :close-on-click-modal="false"
      @click="editCancel"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="120px" label-position="left">
          <el-form-item :label="$t('SeaExport.PaymentNo')">
            <el-input v-model="oneFormData.paymentNo" no="17" style="width: 190px" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PaymentAmount')">
            <el-input-number v-model="oneFormData.forexAmount" no="18" :precision="2" :controls="false" style="width: 190px" @change="forexPaymentChangedHanlder('forexAmount')" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ThePrePayment') + '(RMB)'">
            <el-input-number v-model="oneFormData.paymentPreLocalAmount" no="19" :precision="2" :controls="false" style="width: 190px" @change="forexPaymentChangedHanlder('paymentPreLocalAmount')" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Currency')">
            <el-input v-model="oneFormData.forexCurrency" no="20" :disabled="true" style="width: 190px" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PaymentExchangeRate')">
            <el-input-number v-model="oneFormData.forexExchangeRate" no="21" :precision="6" :controls="false" style="width: 190px" @change="forexPaymentChangedHanlder('forexExchangeRate')" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ActualPaymentAmount') + '(RMB)'">
            <el-input-number v-model="oneFormData.actualPaymentAmount" no="22" :precision="2" :controls="false" :placeholder="$t('SeaExport.RoundPaymentAmountExchangeRate')" style="width: 190px" @change="forexPaymentChangedHanlder('actualPaymentAmount')" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ServiceCharge') + '(RMB)'">
            <el-input-number v-model="oneFormData.commission" no="23" :precision="2" :controls="false" style="width: 190px" @change="forexPaymentChangedHanlder('commission')" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PostalCharges') + '(RMB)'">
            <el-input-number v-model="oneFormData.postalCommission" no="24" :precision="2" :controls="false" style="width: 190px" @change="forexPaymentChangedHanlder('postalCommission')" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.AcceptanceFee') + '(RMB)'">
            <el-input-number v-model="oneFormData.acceptCommission" no="25" :precision="2" :controls="false" style="width: 190px" @change="forexPaymentChangedHanlder('acceptCommission')" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.RetreatMoreFillLessAmount') + '(RMB)'">
            <el-input-number v-model="oneFormData.diffAmount" no="26" :precision="2" :controls="false" :disabled="true" :placeholder="$t('SeaExport.AdvancePayment_ActualAmount_HandlingCharge_PostTelecommunicationCharge_AcceptanceHandlingCharge')" style="width: 190px" @change="forexPaymentChangedHanlder('diffAmount')" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PaymentDate')">
            <el-date-picker v-model="oneFormData.paymentDate" no="27" :editable="false" type="date" value-format="yyyy-MM-dd" style="width: 190px" :clearable="false" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="28" type="primary" @click="confirmAdd">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="29" @click="editCancel">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { cacheName, cache } from '@/utils/cacheManager'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { Job } from '@/class/model/booking/Job'
import { PoList } from '@/class/model/booking/PoList'
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { User } from '@/class/model/sys/User'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import StrUtils from '@/utils/StrUtils'
import { TabError } from '@/utils/class/TabError'
import * as NumberUtils from '@/utils/NumberUtils'
import uidUtil from '../../../../../../../utils/uidUtil'
import { deepCopy } from '@/utils/commonUtil'

export default {
  name: 'TabTradeCommission',
  components: { cargoAdvanceSelect, cargoUserSelect },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      URL,
      selectTypeNames: TYPE_NAMES,
      officeUserList: [],
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: event => {
          this.selectedData = event.data
        },
        onRowDoubleClicked: this.forexPaymentDoubleClikc,
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          if (this.gridOptions.api && event.column) {
            this.gridOptions.api.forEachNode(node => {
              if (node.rowIndex === event.rowIndex) {
                this.selectedData = node.data
              }
            })
          }
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.PaymentNo'),
          field: 'paymentNo',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.PaymentAmount'),
          field: 'forexAmount',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ThePrePayment') + '(RMB)',
          field: 'paymentPreLocalAmount',
          width: 160,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Currency'),
          field: 'forexCurrency',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.PaymentExchangeRate'),
          field: 'forexExchangeRate',
          width: 120,
          cellRenderer: (params) => {
            if (params.data && params.data.uuid === 'pinnedBottomRowDataUuid') return ''
            return ColumnUtils.formatNumber(params.value, 6)
          }
        },
        {
          headerName: this.$t('SeaExport.ActualPaymentAmount') + '(RMB)',
          field: 'actualPaymentAmount',
          width: 170,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ServiceCharge') + '(RMB)',
          field: 'commission',
          width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.PostalCharges') + '(RMB)',
          field: 'postalCommission',
          width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.AcceptanceFee') + '(RMB)',
          field: 'acceptCommission',
          width: 160,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.RetreatMoreFillLessAmount') + '(RMB)',
          field: 'diffAmount',
          width: 170,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.PaymentDate'),
          field: 'paymentDate',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }
      ],
      gridApi: null,
      editDialog: {
        visible: false,
        isNew: false,
        title: ''
      },
      currentUser: {},
      job: new Job(),
      poList: new PoList().fillDefaultValue().getData(),
      forexPayment: [],
      oneFormData: {},
      selectedData: null,
      sales: 0,
      total: {
        total: '',
        orderAmount: '',
        paymentAmount: '',
        unpaidAmount: ''
      },
      customerName: ''
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    }
  },
  watch: {
    // job上的 信息修改同步 poList
    'job.sales': {
      handler: function(val) {
        this.poList.sales = this.job.sales
        this.poList.supportor = (this.poList.supportor === 0 || !this.poList.supportor) ? this.poList.sales : this.poList.supportor
        this.txtSalesChangeHandler()
      },
      deep: true
    },
    'job.customerId': {
      handler: function(val) {
        this.poList.customerId = val
        if (val > 0) {
          this.customerName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', this.poList.customerId, 'chineseName')
        } else {
          this.customerName = ''
        }
      },
      deep: true
    },
    '$store.getters.currentOfficeId': {
      immediate: true,
      handler: function(newVal) {
        if (newVal > 0) {
          User.getAllUsersByOffice(newVal).then(data => {
            this.officeUserList = data
          })
        } else {
          this.officeUserList = []
        }
      }
    }
  },
  methods: {
    poExchangeRateChange() {
      this.poList.poExchangeRate = !this.poList.poExchangeRate ? '' : this.poList.poExchangeRate
    },
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        // 货物明细页签录入Amount金额没同步到贸易页签的订单金额(用于tab 已打开不再刷新 重新计算订单金额)
        this.poItemsCollectionChangeHandler()
        return
      }
      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.currentUser = cache.user
      this.job = row
      const job = new SeaExportJob(row)
      await Promise.all([
        job.getPoItems(),
        job.getPoList()
      ])
      if (this.isEdit && this.job.uuid) {
        this.$emit('syncData', { poList: deepCopy(this.job.poList) })
      }

      if (this.job.poList && this.job.poList.length > 0) {
        this.poList = this.job.poList[0]
        this.poList.supportor = this.poList.supportor || this.poList.sales
        this.forexPayment = job.poList[0].forexPaymentList
        this.footerTotal()
      } else {
        this.poList = new PoList().fillDefaultValue().getData()
        this.poList.jobUuid = job.uuid
        this.forexPayment = this.poList.forexPaymentList
        if (!this.forexPayment) {
          this.forexPayment = []
        }
      }

      // 新增情况下，同步job 上的 sale,customer
      if (StrUtils.isEmpty(this.poList.uuid)) {
        this.poList.customerId = this.job.customerId
        this.customerName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', job.customerId, 'chineseName')
        this.poList.sales = this.job.sales
        this.txtSalesChangeHandler()
      }

      this.poList.supportor = (this.poList.supportor === 0 || !this.poList.supportor) ? this.poList.sales : this.poList.supportor

      // 底部合计
      this.totalCount()
      this.txtSalesChangeHandler()
      this.poItemsCollectionChangeHandler()
      if (!this.job || !this.poList || this.job.poList.length === 0) {
        this.poList.poCurrency = 'USD'
        this.poList.poNo = ''
        this.poList.commisionDiscount = 100
      }
    },
    txtSalesChangeHandler() {
      // 同步实现 getSalesDepResult
      if (this.job.sales) {
        const user = getObjectByCache(basicCacheKeys.basic_data_User, 'userId', Number(this.job.sales))
        if (user) {
          this.poList.salesDepartment = user.defaultOfficeId
          this.poList.salesOffice = user.defaultDepId
        } else {
          this.poList.salesDepartment = 0
          this.poList.salesOffice = 0
        }
      }
    },
    poItemsCollectionChangeHandler() {
      let result = 0
      if (this.job.poItems && this.job.poItems.length > 0) {
        for (const poItems of this.job.poItems) {
          result += Number(poItems.purchaseAmount)
        }
      }
      if (this.poList) { this.poList.poAmount = result || 0 }
      this.poList.diffAmount = this.poList.poAmount - this.poList.poDeclareAmount
    },
    getSubmitData() {
      this.validateForm()
      const job = { ...this.job }
      return {
        job,
        poList: this.poList
      }
    },
    validateForm() {
      this.checkModel()
    },
    checkModel() {
      if (!this.job.itmService) {
        // 不需要 poList 单独组装后提交保存
        /* if (job.poList && job.poList.length > 0) {
          job.poList.removeAll()
        }*/
        return true
      } else {
        if (!this.validate()) { return false }
        this.fillModel()
        if (!this.job.poList) {
          this.job.poList = []
        }
        /* if (!this.poList.contains(_poList)) {
          _poList.job = job
        }*/
        return true
      }
    },
    validate() {
      if (StrUtils.isEmpty(String(this.poList.customerId))) {
        throw new TabError(this.$t('Message.TradeCommissionedUnitCannotBeEmpty'), 'tabTradeCommission')
      }
      if (StrUtils.isEmpty(String(this.poList.supportor))) {
        throw new TabError(this.$t('Message.TradeSalesSupportCannotBeEmpty'), 'tabTradeCommission')
      }
      if (StrUtils.isEmpty(this.poList.poCurrency)) {
        throw new TabError(this.$t('Message.TradingCurrencyCannotBeEmpty'), 'tabTradeCommission')
      }
      if (StrUtils.isEmpty(String(this.poList.poExchangeRate))) {
        throw new TabError(this.$t('Message.TradingExchangeRateCannotBeEmpty'), 'tabTradeCommission')
      }
      if (StrUtils.isEmpty(String(this.poList.commisionDiscount))) {
        throw new TabError(this.$t('Message.TradeServiceFeeDiscountRateCannotBeEmpty'), 'tabTradeCommission')
      }
      if (this.getGridForexAmount() > this.poList.poAmount) {
        throw new TabError(this.$t('Message.TradeTheAmountOfWriteOffsCannotBeGreaterThanTheAmountOfOrders'), 'tabTradeCommission')
      }
      for (const doc of this.forexPayment) {
        if (!doc.paymentNo || StrUtils.isEmpty(doc.paymentNo.trim())) {
          throw new TabError(this.$t('Message.TradePaymentNOCannotBeEmpty'), 'tabTradeCommission')
        }
        if (doc.paymentNo && doc.paymentNo.length > 16) {
          throw new TabError(this.$t('Message.TradePaymentNumberCannotBeGreaterThanBitsInLength'), 'tabTradeCommission')
        }
      }
      return true
    },
    fillModel() {
      this.poList.forexPaymentList = this.forexPayment
    },
    forexPaymentDoubleClikc() {
      this.addBtnClickHandler(false)
    },
    // 新增/编辑
    addBtnClickHandler(isNew) {
      if (this.readonly) {
        return
      }
      if (isNew) {
        this.editDialog.title = this.$t('Payment.new')
        this.oneFormData = { ...this.initForexPayment() }
        this.oneFormData.tempUuid = uidUtil.createUID()
        this.oneFormData.paymentDate = new Date()
        this.oneFormData.forexCurrency = this.poList.poCurrency
      } else {
        this.editDialog.title = this.$t('SeaExport.Edit')

        if (!this.selectedData) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }

        if (!this.selectedData.hasOwnProperty('tempUuid')) {
          this.selectedData.tempUuid = uidUtil.createUID()
        }
        this.oneFormData = { ...this.selectedData }
      }
      this.editDialog.isNew = isNew
      this.editDialog.visible = true
    },
    initForexPayment() {
      const initData = {
        uuid: '',
        paymentNo: '',
        paymentDate: '',
        forexType: 0,
        referenceNo: '',
        forexAmount: 0.0,
        forexCurrency: '',
        forexExchangeRate: 0.0,
        actualPaymentAmount: 0.0,
        paymentPreLocalAmount: 0.0,
        commission: 0.0,
        postalCommission: 0.0,
        acceptCommission: 0.0,
        diffAmount: 0.0,
        remarks: '',
        opRemarks: ''
      }
      return initData
    },
    // 明细列表-编辑确认
    confirmAdd() {
      if (this.editDialog.isNew) {
        this.forexPayment.push(this.oneFormData)
      } else {
        this.forexPayment = this.forexPayment.map(item => {
          if (item['tempUuid'] === this.oneFormData['tempUuid']) {
            return this.oneFormData
          }
          return item
        })
        this.selectedData = this.forexPayment.find(p => p.tempUuid === this.oneFormData['tempUuid'])

        this.gridApi.refreshCells({ force: true })
      }
      this.footerTotal()
      this.editDialog.visible = false
    },
    // 明细列表-编辑取消
    editCancel() {
      this.editDialog.visible = false
    },
    delBtnClickHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        return
      }
      for (const row of rows) {
        const index = this.forexPayment.indexOf(row)
        this.forexPayment.splice(index, 1)
      }
      this.footerTotal()
    },
    footerTotal() {
      let forexAmount = 0
      let paymentPreLocalAmount = 0
      let actualPaymentAmount = 0
      let commission = 0
      let postalCommission = 0
      let acceptCommission = 0
      let diffAmount = 0
      for (const doc of this.forexPayment) {
        forexAmount += doc.forexAmount
        paymentPreLocalAmount += doc.paymentPreLocalAmount
        actualPaymentAmount += doc.actualPaymentAmount
        commission += doc.commission
        postalCommission += doc.postalCommission
        acceptCommission += doc.acceptCommission
        diffAmount += doc.diffAmount
      }
      const pinnedBottomRowData = [
        {
          uuid: 'pinnedBottomRowDataUuid',
          forexAmount: forexAmount,
          paymentPreLocalAmount: paymentPreLocalAmount,
          actualPaymentAmount: actualPaymentAmount,
          commission: commission,
          postalCommission: postalCommission,
          acceptCommission: acceptCommission,
          diffAmount: diffAmount
        }
      ]
      this.gridApi.setPinnedBottomRowData(pinnedBottomRowData)
      this.gridApi.refreshCells({ force: true })

      this.poList.poDeclareAmount = forexAmount
      this.poList.diffAmount = this.poList.poAmount - this.poList.poDeclareAmount

      this.totalCount()
    },
    totalCount() {
      this.total.total = this.$t('SeaExport.Total')
      this.total.orderAmount = this.poList.poAmount + ' ' + this.poList.poCurrency
      this.total.paymentAmount = this.poList.poDeclareAmount + ' ' + this.poList.poCurrency
      this.total.unpaidAmount = (Number(this.poList.poAmount) - Number(this.poList.poDeclareAmount)) + ' ' + this.poList.poCurrency
    },
    poCurrencyCB_changeHandler(currency) {
      for (const doc of this.forexPayment) {
        doc.forexCurrency = this.poList.poCurrency
      }
      this.gridApi.refreshCells({ force: true })
      this.totalCount()
    },
    forexPaymentChangedHanlder(dateField) {
      this.oneFormData[dateField] = this.oneFormData[dateField] || ''
      if (dateField === 'forexAmount' ||
        dateField === 'forexExchangeRate' ||
        dateField === 'commission' ||
        dateField === 'postalCommission' ||
        dateField === 'acceptCommission' ||
        dateField === 'paymentPreLocalAmount') {
        const diffAmount = this.diffAmountAmountLabelFun(this.oneFormData)
        this.oneFormData.diffAmount = diffAmount
      }
      if (dateField === 'forexAmount' ||
        dateField === 'forexExchangeRate') {
        this.oneFormData.forexAmount = ColumnUtils.roundHalfUp(this.oneFormData.forexAmount, 2)
        this.oneFormData.forexExchangeRate = ColumnUtils.roundHalfUp(this.oneFormData.forexExchangeRate, 4)
        this.oneFormData.actualPaymentAmount = ColumnUtils.roundHalfUp(Number(this.oneFormData.forexAmount) * Number(this.oneFormData.forexExchangeRate), 2)
      }
      if (dateField === 'actualPaymentAmount') {
        this.oneFormData.actualPaymentAmount = ColumnUtils.roundHalfUp(this.oneFormData.actualPaymentAmount, 2)
        this.oneFormData.forexAmount = ColumnUtils.roundHalfUp(this.oneFormData.forexAmount, 2)
        if (Number(this.oneFormData.forexAmount) === 0) {
          this.oneFormData.forexExchangeRate = 0
        } else {
          this.oneFormData.forexExchangeRate = ColumnUtils.roundHalfUp(Number(this.oneFormData.actualPaymentAmount) / Number(this.oneFormData.forexAmount), 4)
        }
      }
      this.poList.poDeclareAmount = this.getGridForexAmount()
    },
    getGridForexAmount() {
      let result = 0
      for (const doc of this.forexPayment) {
        result += doc.forexAmount
      }
      return result
    },
    diffAmountAmountLabelFun(forexPayment) {
      if (forexPayment) {
        const num = forexPayment.paymentPreLocalAmount - forexPayment.forexAmount * forexPayment.forexExchangeRate -
          forexPayment.commission - forexPayment.postalCommission - forexPayment.acceptCommission
        return num.toFixed(2)
      }
      return 0
    },
    actualPaymentAmountLabelFun(item) {
      const uuid = Object.prototype.hasOwnProperty.call(item, 'uuid') ? item.uuid : ''
      if (!uuid) return 0
      const data = this.forexPayment.find(item => item.uuid === uuid)
      if (data) { return (Math.round(Number(data.forexAmount) * Number(data.forexExchangeRate))).toFixed(2) }
      return 0
    }
  }
}
</script>

<style>
</style>
